export default __webpack_public_path__ + "static/media/shopify-icon.bd41159b.png";